import React, { useState } from 'react';

const LEGEND_ITEMS = [
  { color: 'green', label: 'Ahead of pace' },
  { color: 'yellow', label: '1–4 min behind' },
  { color: 'red', label: '5+ min behind, impacting others' },
  { color: 'blue', label: 'Behind, held up by group ahead' },
  { color: 'orange', label: 'Behind, not holding up anyone' },
];

const styles = {
  wrapper: {
    position: 'absolute',
    bottom: 16,
    left: 16,
    zIndex: 1000,
    fontFamily: 'sans-serif',
    fontSize: 14,
  },
  trigger: (hovered) => ({
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 14px',
    backgroundColor: hovered ? '#f5f5f5' : '#fff',
    border: '1px solid #ccc',
    borderRadius: 6,
    cursor: 'pointer',
    boxShadow: '0 1px 4px rgba(0,0,0,0.2)',
    fontWeight: 600,
    color: '#333',
    transition: 'background-color 0.15s ease',
  }),
  triggerChevron: (open) => ({
    fontSize: 10,
    opacity: 0.8,
    transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 0.2s ease',
  }),
  panel: {
    marginTop: 6,
    padding: '10px 12px',
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: 6,
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    minWidth: 280,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 6,
  },
  rowLast: {
    marginBottom: 0,
  },
  swatch: {
    width: 20,
    height: 20,
    borderRadius: 4,
    flexShrink: 0,
  },
  label: {
    color: '#333',
    lineHeight: 1.3,
  },
};

function MapLegend() {
  const [open, setOpen] = useState(true);
  const [hovered, setHovered] = useState(false);

  return (
    <div style={styles.wrapper}>
      <button
        type="button"
        style={styles.trigger(hovered)}
        onClick={() => setOpen((o) => !o)}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        aria-expanded={open}
        aria-label={open ? 'Close pace legend' : 'Open pace legend'}
      >
        <span>Legend</span>
        <span style={styles.triggerChevron(open)} aria-hidden>▼</span>
      </button>
      {open && (
        <div style={styles.panel}>
          {LEGEND_ITEMS.map((item, i) => (
            <div
              key={item.color}
              style={{
                ...styles.row,
                ...(i === LEGEND_ITEMS.length - 1 ? styles.rowLast : {}),
              }}
            >
              <div
                style={{
                  ...styles.swatch,
                  backgroundColor: item.color,
                  border: item.color === 'yellow' ? '1px solid #ccc' : 'none',
                }}
              />
              <span style={styles.label}>{item.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default MapLegend;
